// src/assets/images/index.ts
// よく使用される画像のインポート

// サブディレクトリからのインポート
import CommonImages from "./common";
import DashBoardImages from "./dashBoard";
import WritingImages from "./writing";
import LogoImages from "./logo";
import TopImages from "./top";
import PricingImages from "./pricing";
import TemplateImages from "./template";
import NotesNebulaImages from "./notes-nebula";
import JunoImages from "./juno";

// ルートレベルの画像インポート
import error404 from "./error_404.jpg";
import loading from "./loading.svg";
import maintenance from "./maintenance.jpg";
import noImage from "./no_image.jpg";
import oversizedImage from "./oversized-image.jpg";

// OG画像
import ogJuno from "./og_juno.jpg";
import ogNotesNebula from "./og_notes_nebula.jpg";
import ogTenakAi from "./og_tenak_ai.jpg";

// 既存の構造を維持した画像オブジェクト
export const Images = {
  // エラーと共通
  error404,
  loading,
  maintenance,
  noImage,
  oversizedImage,

  // サブディレクトリからのインポート
  common: CommonImages,
  dashBoard: DashBoardImages,
  writing: WritingImages,
  logo: {
    main: LogoImages.main,
    svg: LogoImages.svg,
    banner: LogoImages.banner,
  },
  juno: {
    logo: JunoImages.logo,
    mini: JunoImages.mini,
    mini2: JunoImages.mini2,
    aboutTop: JunoImages.about.top,
    about: JunoImages.about,
    aiEngine: JunoImages.aiEngine,
    companies: JunoImages.companies,
  },
  tenak: LogoImages.tenak,
  notesNebula: {
    ...NotesNebulaImages,
    ico: LogoImages.notesNebula.ico,
    png: LogoImages.notesNebula.png,
  },
  template: TemplateImages,
  diocode: LogoImages.diocode,
  company: {
    ...TopImages.companies,
    ...JunoImages.companies,
  },
  og: {
    juno: ogJuno,
    notesNebula: ogNotesNebula,
    tenakAi: ogTenakAi,
  },
  pricing: PricingImages,
  top: TopImages,
};

// 個別エクスポート（特定の画像を直接インポートしたい場合のため）
// 各サブディレクトリからのエクスポートを再エクスポート
export { error404, loading, maintenance, noImage, oversizedImage };

// common からのエクスポート
export { bg01 } from "./common";

// dashBoard からのエクスポート
export {
  dashBoardColor,
  dashBoardPrompt,
  dashBoardExplore,
  dashBoardT2i,
  dashBoardI2i,
  dashBoardUpscale,
  dashBoardVideo,
  dashBoardMindmap,
  dashBoardVoice,
  dashBoardWriting,
} from "./dashBoard";

// writing からのエクスポート
export { writingArticle, writingShortVideo, writingSummary } from "./writing";

// junoAiEngine からのエクスポート
export {
  junoAiEngineT2i,
  junoAiEngineI2i,
  junoAiEngineUpscale,
  junoAiEngineEditor,
  junoAiEngineAuraSR,
  junoAiEngineBriaBackgroundReplace,
  junoAiEngineBriaProductShot,
  junoAiEngineClarityUpscaler,
  junoAiEngineCreativeUpscaler,
  junoAiEngineDallE3,
  junoAiEngineFlux1Dev,
  junoAiEngineFlux1DevCannyLoRA,
  junoAiEngineFlux1DevDepthLoRA,
  junoAiEngineFlux1DevFill,
  junoAiEngineFlux1DevRedux,
  junoAiEngineFlux1Pro,
  junoAiEngineFlux1ProCanny,
  junoAiEngineFlux1ProCannyJuno,
  junoAiEngineFlux1ProDepth,
  junoAiEngineFlux1ProDepthJuno,
  junoAiEngineFlux1ProFill,
  junoAiEngineFlux1ProFillJuno,
  junoAiEngineFlux1ProJuno,
  junoAiEngineFlux1RealismLoRA,
  junoAiEngineFlux1Schnell,
  junoAiEngineFlux1SchnellRedux,
  junoAiEngineFlux11Pro,
  junoAiEngineFlux11ProRedux,
  junoAiEngineFlux11ProUltra,
  junoAiEngineFlux11ProUltraJuno,
  junoAiEngineFlux11ProUltraRedux,
  junoAiEngineFluxJuggernautBase,
  junoAiEngineFluxJuggernautJuno,
  junoAiEngineFluxJuggernautLightning,
  junoAiEngineFluxJuggernautPro,
  junoAiEngineFluxJuno,
  junoAiEngineFluxPuLID,
  junoAiEngineGeminiFlashEdit,
  junoAiEngineIcLightV2,
  junoAiEngineImagen3,
  junoAiEngineImagen3Fast,
  junoAiEngineKolorsVTO,
  junoAiEngineLuminaV2,
  junoAiEngineMinimaxImage,
  junoAiEngineRecraftClarityUpscaler,
  junoAiEngineRecraftCreativeUpscaler,
  junoAiEngineRecraftV3,
  junoAiEngineSD,
  junoAiEngineSD3,
  junoAiEngineSD35,
  junoAiEngineSDUltra,
  junoAiEngineSDXL,
} from "./juno/ai-engine";

// juno companies からのエクスポート
export {
  junoCompanyLumaThumbnail,
  junoCompanyKlingThumbnail,
  junoCompanyPikaThumbnail,
  junoCompanyPixverseThumbnail,
  junoCompanyHailuoThumbnail,
  junoCompanyHaiperThumbnail,
  junoCompanyRunwayThumbnail,
  junoCompanyViduThumbnail,
  junoCompanyWanThumbnail,
} from "./juno/companies";

// notes-nebula からのエクスポート
export { notesNebulaTop } from "./notes-nebula";

// template からのエクスポート
export {
  templateTop,
  template0,
  template1,
  template2,
  template3,
  template4,
  template5,
  template6,
  template7,
  template8,
  template9,
  template10,
  template11,
  template12,
  template13,
  template14,
  template15,
  template16,
  template17,
  template18,
  template19,
  template20,
  template21,
  template22,
  template23,
  template24,
  template25,
  template26,
  template27,
  template28,
  template29,
  template30,
  template31,
  template32,
  template33,
} from "./template";

// juno about からのエクスポート
export {
  junoAboutTop,
  junoAboutT2iBefore,
  junoAboutT2iAfter,
  junoAboutI2iBefore,
  junoAboutI2iAfter,
  junoAboutSample01,
  junoAboutBefore01,
  junoAboutAfter01,
  junoAboutEditSample,
  junoAboutEditBefore,
  junoAboutEditAfter,
  junoAboutRelightBefore,
  junoAboutRelightAfter,
  junoAboutProductBefore,
  junoAboutProductAfter,
  junoAboutSection21,
  junoAboutSection22,
  junoAboutSection23,
} from "./juno/about";

// logo からのエクスポート
export {
  logo,
  logoSvg,
  logoBanner,
  junoLogoMini,
  junoLogoMini2,
  junoLogo,
  logoZISmall,
  logoZI,
  logoZISvg,
  nnIco,
  nnPng,
  diocodeBlack,
  diocodeWhite,
} from "./logo";

// company からのエクスポート
export { companyOpenAI, companyGoogle } from "./top";

export {
  companyLuma,
  companyKling,
  companyPika,
  companyPixverse,
  companyHailuo,
  companyHaiper,
  companyRunway,
  companyVidu,
  companyWan,
  companyBytedance,
  companySync,
  companyRealesrgan,
  companyTopazlabs,
} from "./juno/companies";

// OG画像のエクスポート
export { ogJuno, ogNotesNebula, ogTenakAi };

// pricing からのエクスポート
export { pricingTop } from "./pricing";

// top からのエクスポート
export {
  topBrowsing,
  topEditor,
  topFVZO,
  topMindmap,
  topWoman,
  topWhatIs,
  topPromptTemplate,
  topAstronaut,
} from "./top";
